module.exports = __webpack_public_path__ + "static/img/img7.ab45e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img7.png
// module id = pdvV
// module chunks = 0